import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';
import { settings } from './setup';

/**
 * Retract a XR app
 * @param {object} params - an object of params
 * @param {string} params.accessToken - the access token required to perform the operation
 * @param {string} params.orgId - the ID of the org that owns the app
 * @param {string} params.appId - the ID of the app
 * @param {string} params.email - user's email
 * @param {string} params.name - user's display name
 */
export default async (params, signal = null) => {
  const requiredParams = ['accessToken', 'orgId', 'appId', 'email', 'name'];
  const paramsRules = {
    accessToken: { allowedTypes: ['string'] },
    orgId: { allowedTypes: ['string'] },
    appId: { allowedTypes: ['string'] },
    email: { allowedTypes: ['string'] },
    name: { allowedTypes: ['string'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const response = await fetch(
    `${settings.endpoint}/v2/org/${params.orgId}/app/${params.appId}/retract?api_key=${settings.apiKey}`,
    {
      signal,
      method: 'POST',
      headers: { Authorization: params.accessToken, 'Content-Type': 'application/json;charset=UTF-8' },
      body: JSON.stringify({ email: params.email, name: params.name }),
    }
  );
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return content;
  }
};
